import { inject, Injectable, isDevMode } from '@angular/core';
import { SetupHandler } from './setup.handler';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '@aipb/util/theme';
import { CONFIG_THEME } from '@aipb/util/di';

@Injectable({
  providedIn: 'root'
})
export class ThemeHandler extends SetupHandler {
  #document = inject(DOCUMENT);
  #themeService = inject(ThemeService);
  #theme = inject(CONFIG_THEME);

  constructor() {
    super('🎨 theme.handler');
  }

  handle() {
    if (isDevMode()) {
      const debugScreensClass = 'debug-screens';
      this.#document.body.classList.add(debugScreensClass);
      this.addLogMessage(`added class ${debugScreensClass} to body`);
    }

    if (!this.#theme) return;

    const sourceColor = this.#theme?.sourceColor || '#abed12';
    this.#themeService.generateDynamicTheme(sourceColor);
    this.#themeService.generateToolbarTheme(this.#theme?.toolbar);
    this.#themeService.generateSidebarHeaderTheme(this.#theme?.sidebarHeader);
    this.addLogMessage(`generate theme with sourceColor=${sourceColor}`);
  }
}
